import React from 'react';
import classnames from 'classnames';
import { Svg } from 'src/components/Svg/Svg';

import classes from './WhatsAppChat.scss';

export const WhatsAppChat: React.FC<{ isFooterElement?: boolean; theme?: 'white' | 'black' }> = ({
    isFooterElement = false,
    theme = 'white',
}) => {
    const phoneNumber = '441913130015';

    return (
        <div
            className={classnames(classes.wrapper, {
                [classes.isFooterElement]: isFooterElement,
                [classes.black]: theme === 'black',
                [classes.white]: theme === 'white',
            })}
        >
            <a
                href={`https://api.whatsapp.com/send?phone=${phoneNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.icon}
                aria-label="WhatsApp Chat"
            >
                <Svg name="whatsapp" />
                <span>WhatsApp Chat</span>
            </a>
        </div>
    );
};
